
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Auth',

  mounted() {
    document.body.style.paddingTop = '';
  },

  updated() {
    document.body.style.paddingTop = '';
  },
});
